import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { RequestEntity, ISubcategoriesIDsCategoriesForAssignDishes } from 'types';
import {
	IDishAssignmentContext,
	DishAssignmentContext,
} from '../../../../../dishAssignmentState/dishAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { AssignImg } from 'components/AssignImg/AssignImg';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Subcategory.module.scss';

interface ISubcategory {
	data: ISubcategoriesIDsCategoriesForAssignDishes[];
}

export const Subcategory: React.FC<ISubcategory> = ({ data }) => {
	const { setIDsSelectedSubcategories, IDsSelectedSubcategories } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const handleChange = (isChecked: boolean, subcategoryID: string) => {
		if (isChecked) {
			const copyIDsSelectedSubcategories = { ...IDsSelectedSubcategories };
			copyIDsSelectedSubcategories[subcategoryID] = true;
			setIDsSelectedSubcategories(copyIDsSelectedSubcategories, true);
		} else {
			const copyIDsSelectedSubcategories = { ...IDsSelectedSubcategories };
			delete copyIDsSelectedSubcategories[subcategoryID];
			setIDsSelectedSubcategories(copyIDsSelectedSubcategories, true);
		}
	};

	return (
		<div className={style.container} data-test="Subcategory">
			{data.map((el) => {
				const isChecked = el.id in IDsSelectedSubcategories;
				const isHasAssignedDishes = el.hasAssignedDishes;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHasAssignedDishes,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.id + 'mainDisplaySubcategoryItem'}>
						<div className={style.imageWrapper}>
							<ImgUploaderByEntityId
								resource={RequestEntity.SubcategoriesMenuV2}
								entityID={el.filePath ? el.id : ''}
								isMenuV2={true}
								photoSize="Small"
								loaderSize="small"
								noImageIdIcon="menu"
							/>
							{isHasAssignedDishes ? <AssignImg name="assignedDishLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.id)}
								checked={isChecked}
							/>
							<Text translationKey={el.name} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};
